var map = {
	"./culik/login-min.png": "63c8",
	"./menanga/login-min.png": "9fd7",
	"./remun-surat/login-min.png": "c59a",
	"./sangsit/login-min.png": "5976",
	"./sibetan/login-min.png": "909d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7cd4";